import React, { useEffect, useState } from 'react';
import "./DateTime.scss"

import { getWeekdayByDate, getMonthByDate } from '../../../helpers/datetime';

const DateTime = () => {
	const [ hours, setHours ] = useState(0);
	const [ minutes, setMinutes ] = useState(0);

	const [ date, setDate ] = useState('');
	const [ weekDay, setWeekDay ] = useState('');

	useEffect(() => {
		setCurrentDate();
		setCurrentTime();
		setInterval(() => {
			setCurrentTime();
		}, 1000);
	}, [])

	const setCurrentTime = () => {
		const date = new Date();
		setHours(date.getHours())
		setMinutes(date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes())
	}

	const setCurrentDate = () => {
		const date = new Date();
		setDate(date.getDate() + ' ' + getMonthByDate(date, true))
		setWeekDay(getWeekdayByDate(date));
	}

	return (
		<div className="datetime">
			<div className="datetime__time">
				{hours}<span>:</span>{minutes}
			</div>
			<div className="datetime__date">
				{weekDay} <br></br>
				{date}
			</div>
		</div>

	);
};

export default DateTime;
